var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-active' : _vm.active, 'is-closing' : _vm.closing  },on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.close.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }